import React, { useMemo } from 'react';
import { Button } from 'reactstrap';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { formatarDocumento } from '../../../utils/documentoAlfanumerico';

const formatDateTimePtBrNoComma = value => {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';

  const data = d.toLocaleDateString('pt-BR');
  const hora = d.toLocaleTimeString('pt-BR', { hour12: false });
  return `${data} ${hora}`;
};

const useDataGridColumns = ({ verRegistros, baixarArquivoImportadoS3 }) => {
  const colunasArquivos = useMemo(
    () => [
      {
        dataField: 'dataProcessamento',
        text: 'Data de processamento',
        tdAlign: 'center',
        tipoOrdenacao: 'data',
        formatter: (_, row) => formatDateTimePtBrNoComma(row.dataProcessamento)
      },
      { dataField: 'nomeArquivo', text: 'Nome do arquivo', tdAlign: 'left', tipoOrdenacao: 'texto' },
      {
        dataField: 'qtdRegistros',
        text: 'Qtd. registros',
        tdAlign: 'center',
        tipoOrdenacao: 'numerico'
      },
      {
        dataField: 'usuarioInclusao',
        text: 'Usuário inclusão',
        tdAlign: 'left',
        tipoOrdenacao: 'texto'
      },
      {
        dataField: 'possuiNaoIntegrados',
        text: 'Possui registros não integrados?',
        tdAlign: 'center',
        tipoOrdenacao: 'booleanTexto',
        formatter: (_, row) => (row.possuiNaoIntegrados ? 'Sim' : 'Não')
      },
      {
        dataField: 's3path',
        text: 'Arquivo (Download)',
        tdAlign: 'center',
        sort: false,
        formatter: (_, row) => {
          const isDownloading = !!row.__downloading;

          return (
            <div className="at-btn-grid">
              {isDownloading ? (
                'Baixando...'
              ) : (
                <Button
                  disabled={isDownloading}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    baixarArquivoImportadoS3(row.s3path, row.nomeArquivo, row.uuid);
                  }}
                  className="at-btn-icon"
                  color="link"
                >
                  <i className="fa fa-download" />
                </Button>
              )}
            </div>
          );
        }
      },
      {
        dataField: 'uuid',
        text: 'Ações',
        tdAlign: 'center',
        sort: false,
        formatter: (_, row) => (
          <div className="at-btn-grid">
            <Button
              className="at-btn-icon"
              type="button"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                verRegistros(row);
              }}
            >
              <i className="fa fa-eye" />
            </Button>
          </div>
        )
      }
    ],
    [verRegistros, baixarArquivoImportadoS3]
  );

  const colunasRegistros = useMemo(
    () => [
      { dataField: 'cedente', text: 'Cedente', tdAlign: 'left', tipoOrdenacao: 'texto' },
      {
        dataField: 'sacadoNome',
        text: 'Sacado',
        tdAlign: 'left',
        tipoOrdenacao: 'texto',
        formatter: (_, row) =>
          `${row.sacadoNome}${row.cpfCnpjSacado ? ` - ${formatarDocumento(row.cpfCnpjSacado)}` : ''}`
      },
      { dataField: 'numeroDocumento', text: 'Documento', tdAlign: 'center', tipoOrdenacao: 'texto' },
      {
        dataField: 'vencimento',
        text: 'Vencimento',
        tdAlign: 'center',
        tipoOrdenacao: 'data',
        formatter: (_, row) =>
          row.vencimento ? new Date(row.vencimento).toLocaleDateString('pt-BR') : ''
      },
      {
        dataField: 'valor',
        text: 'Valor',
        tdAlign: 'center',
        tipoOrdenacao: 'moeda',
        formatter: (_, row) => row.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },
      { dataField: 'nossoNumero', text: 'Nosso Número', tdAlign: 'center', tipoOrdenacao: 'texto' },
      {
        dataField: 'statusIntegracao',
        text: 'Status',
        tdAlign: 'center',
        tipoOrdenacao: 'texto',
        formatter: (_, row) => (
          <div className="at-icone-status-registro">
            {row.statusIntegracaoOk ? (
              <>
                Encontrado
                <CheckCircleIcon color="success" />
              </>
            ) : (
              <>
                Não encontrado
                <ErrorIcon color="error" />
              </>
            )}
          </div>
        )
      }
    ],
    []
  );

  return { colunasArquivos, colunasRegistros };
};

export default useDataGridColumns;
